import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconFileDownloadLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.025 20.975c.35.35.778.525 1.283.525h11.384c.505 0 .933-.175 1.283-.525.35-.35.525-.778.525-1.283V8.498c0-.241-.047-.473-.14-.695a1.794 1.794 0 0 0-.387-.58l-4.196-4.196a1.794 1.794 0 0 0-.58-.387 1.775 1.775 0 0 0-.695-.14H6.308c-.505 0-.933.175-1.283.525-.35.35-.525.778-.525 1.283v15.384c0 .505.175.933.525 1.283ZM13.5 4v3.596c0 .258.086.473.259.645a.875.875 0 0 0 .645.259H18v11.192a.294.294 0 0 1-.096.212.294.294 0 0 1-.212.096H6.308a.294.294 0 0 1-.212-.096.294.294 0 0 1-.096-.212V4.308c0-.077.032-.148.096-.212A.294.294 0 0 1 6.308 4H13.5Zm-.745 11.434V11.75a.726.726 0 0 0-.215-.535.726.726 0 0 0-.534-.215.726.726 0 0 0-.535.215.726.726 0 0 0-.216.535v3.684l-1.323-1.323a.745.745 0 0 0-.25-.167.65.65 0 0 0-.28-.048.85.85 0 0 0-.275.063.784.784 0 0 0-.473.694.7.7 0 0 0 .225.528l2.494 2.494a.832.832 0 0 0 .633.256.831.831 0 0 0 .633-.256l2.493-2.494a.705.705 0 0 0 .22-.523.742.742 0 0 0-.235-.531.783.783 0 0 0-.527-.225.7.7 0 0 0-.527.225l-1.308 1.307Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
      />
    </Svg>
  );
};

export default IconFileDownloadLine;
